export enum FeatureFlag {
  AlternativeSegmentFeatureFlags = 'core.alternative-segment-feature-flags',
  AppcuesRecommendedPackage = 'core.appcues-recommended-package',
  CmaContactFormsPromo = 'core.cma-contact-forms-promo',
  CmaContactFormsPromoCTAs = 'core.cma-contact-forms-promo-ctas',
  CustomActivityTypes = 'f2f.custom-activity-types',
  DealsIntroductionBlock = 'core.deals-introduction-block',
  EnableCustomerMeetingPromotionalFooter = 'core.enable-customer-meeting-promotional-footer',
  EnableMultipleTimeTrackingsUpsellTooltip = 'timetracking.enable-multiple-time-trackings-upsell-tooltip',
  EnableReferralCampaign = 'core.enable-referral-campaign',
  InvoiceRemindersPaymentTermExceeded = 'core.invoice-reminders-payment-term-exceeded',
  InvoicesIntroductionBlock = 'core.invoices-introduction-block',
  MailingIntroductionBlock = 'core.mailing-introduction-block',
  ProjectsActivityTracking = 'projects.activity-tracking',
  ProjectsBudgetColumns = 'projects.budget-columns',
  ProjectsBulkInvoice = 'projects.bulk-invoice',
  ProjectsCustomFields = 'projects.custom-fields',
  ProjectsCustomUserRates = 'projects.custom-user-rates',
  ProjectsDateDependency = 'projects.date-dependency',
  ProjectsIntroductionBlock = 'core.projects-introduction-block',
  ProjectsInvoiceColumns = 'projects.invoice-columns',
  ProjectsInvoiceProjectDate = 'projects.invoice-project-date',
  ProjectsKanban = 'projects.kanban',
  ProjectsMarkUnderlyingWorkAsDoneWhenClosingAProject = 'projects.mark-underlying-work-as-done-when-closing-a-project',
  ProjectsNewTaskTimer = 'projects.new-task-timer',
  ProjectsNextgenTimeline = 'projects.nextgen-timeline',
  ProjectsProductMaterials = 'projects.product-materials',
  ProjectsQuoteToExistingProject = 'projects.quote-to-existing-project',
  ProjectsSimpleInlineEdit = 'projects.inline-edit-simple',
  ProjectsSmartFilters = 'projects.smart-filters',
  ProjectsStatusColumn = 'projects.status-column',
  ProjectsTimeline = 'projects.timeline',
  ProjectsTimesheetExport = 'projects.timesheet-export',
  ProjectsTimeTrackingDoneTask = 'projects.timetracking-done-task',
  ProjectsTimeTrackingNewTask = 'projects.timetracking-new-task',
  ReactifyCallDetailDialog = 'core.reactify-call-detail-dialog',
  ReactifyCallMarkAsDoneDialogs = 'core.reactify-call-mark-as-done-dialogs',
  ReactifyEmailLink = 'core.reactify-email-link',
  ReactifyMeetingMarkAsDoneDialogs = 'core.reactify-meeting-mark-as-done-dialogs',
  ReactifyTaskMarkedAsDoneDialog = 'core.reactify-task-marked-as-done-dialog',
  ReactifyTelephoneLink = 'core.reactify-telephone-link',
  StatusFilterWbs = 'projects.status-filter-wbs',
  TaskUpdatePrimaryCustomer = 'projects.task-update-primary-customer',
  TimeBudget = 'projects.time-budget',
  TimesheetsIntroductionBlock = 'core.timesheets-introduction-block',
  TwilioVersion = 'core.twilio-js-library-version',
  WorkBreakdownFrontAndCentre = 'projects.work-breakdown-front-and-centre',
}

export enum AccountFeatureFlag {
  RemoveDealNumberFromInvoiceRemarks = 'invoicing.remove-deal-number-from-invoice-remarks',
  InvoiceIncludeProductDescription = 'f2f.invoice-include-product-description',
  TicketsBulkDeleteAction = 'tickets.bulk-delete-action',
  InvoicingAdvancedModeStrict = 'invoicing.advanced-mode-strict',
  InvoiceExport = 'invoicing.invoice-export',
  ProjectsGreenfield = 'projects.greenfield',
  EnableChangeFeaturesDialog = 'signup.enable-signup-trial-feature-personalisation',
  AddMultipleInvoiceBccEmailAddresses = 'invoicing.add-multiple-invoice-bcc-email-addresses',
  NextGenProjectsIntegration = 'projects.nextgen-projects-integration',
  ProjectsBillabilityToggle = 'projects.billability-toggle',
  MultipleDealPipelines = 'core.multiple-deal-pipelines',
  DialogRedesignPhaseSix = 'core.dialog-redesign.phase-6',
  QuotationPreviewExtendedOptions = 'core.quotation-preview-extended-options',
  QuotationPreviewFeature = 'core.quotation-preview-feature',
  DealPhaseColor = 'core.deal-phase-color',
  ProjectsHidePrices = 'projects.hide-prices',
  EnableBelgianLateFeeCalculation = 'atlas.atlas-enable-belgian-late-fee-calculation',
  LinkedCreditNotesOnQuotations = 'core.linked-credit-notes-on-quotations',
  DashingDashboard = 'core.dashing-dashboard',
  ResourcePlanning = 'planning.resource-planning',
  LooseTasks = 'projects.loose-tasks',
  EnableAppleIdentityProvider = 'core.enable-apple-identity-provider',
  EnableMicrosoftIdentityProvider = 'core.enable-microsoft-identity-provider',
  IntroduceWeightedAndAbsoluteFilter = 'deals.introduce-weighted-and-absolute-filter',
  CrmStatusFilteredWidgets = 'core.crm-status-filtered-widgets',
  ProjectsMigrationPreview = 'projects.migration-preview',
  MarkQuotationAsSent = 'core.mark-quotation-as-sent',
  MarkQuotationAsRefused = 'core.mark-quotation-as-refused',
  EnablePricingAndPackaging20241 = 'payments.enable-pricing-and-packaging-2024-1',
  DealPickerOnMeetingTaskCall = 'core.deal-picker-on-meeting-task-call',
}

export type FeatureFlagValue = boolean | string | null | 0 | 1;

export interface LegacyFeatureFlagValue {
  id: number;
  value: 'on' | 'off';
  extraInfo: string | null;
}

export const getAll = () => {
  return window.top!.__INITIAL_STATE__.user.featureFlags;
};

export const get = (key: FeatureFlag, defaultValue?: FeatureFlagValue) => {
  const featureFlagValue = window.top!.__INITIAL_STATE__.user.featureFlags[key];
  return typeof featureFlagValue === 'undefined' ? defaultValue : featureFlagValue;
};

export const getAllEnabled = () => {
  const { featureFlags } = window.top!.__INITIAL_STATE__.user;
  return Object.keys(featureFlags).filter((featureFlag) => featureFlags[featureFlag]);
};

export const getAccountFeatureFlag = (key: AccountFeatureFlag, defaultValue?: FeatureFlagValue) => {
  const featureFlagValue = window.top!.__INITIAL_STATE__.account.featureFlags[key];
  return typeof featureFlagValue === 'undefined' ? defaultValue : featureFlagValue;
};
